// extracted by css-extract-rspack-plugin
export default {"budgetLayoutRoot":"qeYDQk"};